import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CometaSelectComponent from './CometaSelectComponent';

var CometaSelect =
/*#__PURE__*/
function (_Component) {
  _inherits(CometaSelect, _Component);

  function CometaSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CometaSelect);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CometaSelect)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleChange = function (option) {
      var _this$props = _this.props,
          handleChange = _this$props.handleChange,
          name = _this$props.name;
      handleChange(name, option);
    }, _temp));
  }

  _createClass(CometaSelect, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          listName = _this$props2.listName,
          validate = _this$props2.validate,
          label = _this$props2.label,
          displayNotes = _this$props2.displayNotes,
          isCreatable = _this$props2.isCreatable,
          country = _this$props2.country,
          language = _this$props2.language,
          placeholder = _this$props2.placeholder,
          id = _this$props2.id;
      return React.createElement(Field, {
        id: id,
        name: name,
        isCreatable: isCreatable,
        listName: listName,
        validate: validate,
        displayNotes: displayNotes,
        label: label,
        handleChange: this.handleChange,
        component: CometaSelectComponent,
        country: country,
        language: language,
        placeholder: placeholder,
        sortAlphabetical: true
      });
    }
  }]);

  return CometaSelect;
}(Component);

;
CometaSelect.propTypes = {
  name: PropTypes.string.isRequired,
  isCreatable: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.object.isRequired,
  displayNotes: PropTypes.string,
  validate: PropTypes.array,
  country: PropTypes.string,
  language: PropTypes.string,
  placeholder: PropTypes.string
};
export default CometaSelect;